<oiq-ui-dropdown #dropdownRef="OiqUiDropdown" [overlayPositions]="overlayPositions">
  <button
    class="rounded-lg px-1 pt-1 text-gray-6"
    type="button"
    id="notifications"
    (click)="onButtonClick()">
    <span class="material-icons">email</span>
  </button>
  <ng-template #dropdownTemplate>
    <!--<div class="oiq-ui-tabs w-full p-4">
      <button type="button" class="oiq-button">Web Links</button>
      <button type="button" class="oiq-button">Cross Collateralization</button>
      <button type="button" class="oiq-button !border-dashed !shadow-none !drop-shadow-none">
        + Add Cross Collateralization
      </button>
    </div>-->

    <div class="oiq-email-button-panel oiq-ui-dialog onyxiq-theme-v2 w-[555px]">
      <header>
        <div class="__title">
          <div class="flex items-center gap-2">
            <h2 class="!text-left !text-base !leading-none !text-gray-1">Email Application</h2>
            @if (isAuthenticated()) {
              <oiq-email-providers-switch
                (addMailboxClicked)="onAddMailbox()"></oiq-email-providers-switch>
            }
          </div>

          <div class="flex items-center justify-end gap-2">
            <button (click)="onRefreshEmails()" type="button" title="Refresh emails">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 0.879685V3.87968C12 4.01229 11.9473 4.13947 11.8536 4.23324C11.7598 4.32701 11.6326 4.37968 11.5 4.37968H8.5C8.36739 4.37968 8.24021 4.32701 8.14645 4.23324C8.05268 4.13947 8 4.01229 8 3.87968C8 3.74708 8.05268 3.6199 8.14645 3.52613C8.24021 3.43236 8.36739 3.37968 8.5 3.37968H10.2931L9.37875 2.46531C8.44948 1.53181 7.1878 1.00516 5.87063 1.00093H5.8425C4.53636 0.997873 3.28151 1.50911 2.34937 2.42406C2.25389 2.5132 2.12731 2.56143 1.99672 2.55843C1.86612 2.55544 1.74189 2.50145 1.65059 2.40803C1.55929 2.31461 1.50817 2.18916 1.50818 2.05854C1.50819 1.92791 1.55932 1.80247 1.65062 1.70906C2.78033 0.604932 4.29988 -0.00914092 5.87952 0.000102868C7.45916 0.00934666 8.97142 0.641162 10.0881 1.75843L11 2.67281V0.879685C11 0.747076 11.0527 0.619899 11.1464 0.526131C11.2402 0.432363 11.3674 0.379685 11.5 0.379685C11.6326 0.379685 11.7598 0.432363 11.8536 0.526131C11.9473 0.619899 12 0.747076 12 0.879685ZM9.65063 9.33531C8.70927 10.2548 7.44337 10.7662 6.12747 10.7585C4.81156 10.7507 3.55175 10.2246 2.62125 9.29406L1.70688 8.37968H3.5C3.63261 8.37968 3.75979 8.32701 3.85355 8.23324C3.94732 8.13947 4 8.01229 4 7.87968C4 7.74708 3.94732 7.6199 3.85355 7.52613C3.75979 7.43236 3.63261 7.37968 3.5 7.37968H0.5C0.367392 7.37968 0.240215 7.43236 0.146447 7.52613C0.0526785 7.6199 0 7.74708 0 7.87968V10.8797C0 11.0123 0.0526785 11.1395 0.146447 11.2332C0.240215 11.327 0.367392 11.3797 0.5 11.3797C0.632608 11.3797 0.759785 11.327 0.853553 11.2332C0.947321 11.1395 1 11.0123 1 10.8797V9.08656L1.91438 10.0009C3.02951 11.1217 4.544 11.7538 6.125 11.7584H6.15812C7.72568 11.7625 9.23171 11.1488 10.35 10.0503C10.4413 9.9569 10.4924 9.83146 10.4924 9.70083C10.4925 9.5702 10.4413 9.44476 10.35 9.35134C10.2587 9.25792 10.1345 9.20393 10.0039 9.20094C9.87332 9.19794 9.74674 9.24617 9.65125 9.33531H9.65063Z"
                  fill="#8A8F9B" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      <main
        style="overflow: hidden"
        class="flex flex-col gap-2 bg-white"
        [class.!px-4]="!isAuthenticated()"
        [class.!p-0]="isAuthenticated()"
        [class.!overflow-hidden]="!isAuthenticated()"
        [class.!overflow-y-auto]="isAuthenticated()">
        @if (isAuthenticated()) {
          <div class="oiq-ui-tabs w-full px-4 pt-4">
            @for (label of inboxAndSentLabels(); track label.id) {
              <button
                type="button"
                class="oiq-button"
                [class.active]="activeTab() === label.id"
                (click)="onTabClick(label)">
                {{ label.name }}
              </button>
            }
          </div>

          <!-- Connected state - show emails -->
          <div class="flex flex-col gap-2">
            @if (isLoading() && displayEmails().length === 0) {
              <!-- Loading emails - show skeleton loaders -->
              @for (item of skeletonItems; track $index) {
                <oiq-email-list-item-skeleton></oiq-email-list-item-skeleton>
              }
            } @else if (displayEmails().length > 0) {
              <!-- Display first 4 emails -->
              <div class="flex flex-col">
                @for (email of displayEmails(); track email.ID) {
                  <a
                    oiq-email-list-item
                    [routerLink]="['/v2', 'email-app', email.ID]"
                    [queryParams]="{ label: activeTab() || 'inbox' }"
                    [email]="email"
                    (click)="dropdownRef.close()"></a>
                }
              </div>
            } @else {
              <!-- No emails -->
              <div class="flex flex-col items-center justify-center gap-2 py-8">
                <span class="material-symbols-outlined text-4xl text-gray-300">mail</span>
                <p class="text-sm text-gray-500">No emails found</p>
              </div>
            }
          </div>
        } @else {
          <!-- Normal state - provider selection -->
          <oiq-email-provider-select (providerSelected)="onAuth($event)">
          </oiq-email-provider-select>
        }
      </main>
      <footer>
        <!--    <div class="flex w-full flex-col items-center justify-center">-->
        <!--      <button-->
        <!--        type="button"-->
        <!--        class="oiq-button oiq-button&#45;&#45;link"-->
        <!--        (click)="openEditCalendarEventDialog([])">-->
        <!--        +Add new-->
        <!--      </button>-->
        <!--    </div>-->

        <div class="flex w-full items-center justify-between">
          @if (isAuthenticated()) {
            <a
              routerLink="/v2/email-app"
              [queryParams]="{ label: activeTab() || 'inbox' }"
              class="oiq-button oiq-button--outline"
              (click)="dropdownRef.close()">
              Full View
            </a>

            <a
              routerLink="/v2/email-app/new"
              class="oiq-button oiq-button--primary--solid"
              (click)="dropdownRef.close()">
              Compose
            </a>
          } @else {
            <button
              type="button"
              class="oiq-button oiq-button--outline"
              (click)="dropdownRef.close()">
              Close
            </button>
          }
        </div>
      </footer>
    </div>
  </ng-template>
</oiq-ui-dropdown>
